import { useState } from 'react';
import { DangerousHtmlContent, Notification, variants } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { TripCharacteristics } from '@eti/schema-types';
import useSelfServiceRebooking from '../../../../common/self-service-rebooking/useSelfServiceRebooking';
import { HAS_CLOSED_NOT_VALID_VOUCHER_MESSAGE } from '../../constants/sessionStorage';

interface VoucherNotValidNotificationProps {
  tripCharacteristics: TripCharacteristics[];
}

const VoucherNotValidNotification = ({ tripCharacteristics }: VoucherNotValidNotificationProps) => {
  const { t } = useTranslation();
  const { isSelfServiceRebooking } = useSelfServiceRebooking();
  const [showVoucherNotValidMessage, setShowVoucherNotValidMessage] = useState(() => {
    const storedValue = sessionStorage.getItem(HAS_CLOSED_NOT_VALID_VOUCHER_MESSAGE);
    return storedValue ? !JSON.parse(storedValue) : true;
  });
  const voucherNotValid = !tripCharacteristics.includes(TripCharacteristics.ValidWithVoucher);

  const handleCloseNotification = () => {
    setShowVoucherNotValidMessage(false);
    sessionStorage.setItem(HAS_CLOSED_NOT_VALID_VOUCHER_MESSAGE, 'true');
  };

  return isSelfServiceRebooking && voucherNotValid && showVoucherNotValidMessage ? (
    <Notification
      dataTestId="payment-page-voucherNotValid"
      onClose={handleCloseNotification}
      title={t('SelfServiceRebooking.VoucherNotValid.Label')}
      variant={variants.WARNING}
    >
      <DangerousHtmlContent content={t('SelfServiceRebooking.VoucherNotValid.Text')} />
    </Notification>
  ) : null;
};

export default VoucherNotValidNotification;
